import { FunctionComponent } from "react";
import { useLocation } from "react-router-dom";
import { ErrorDetails, ErrorPage as SharedErrorPage } from "@fyrstain/hl7-front-library";
import { Title } from "@fyrstain/fhir-front-library";
import i18n from "i18next";
import ApolloPage from "../../components/ApolloPage/ApolloPage";
import { toPublicUrl } from "../../services/PublicUrl";

interface ErrorPageProps {
    error?: ErrorDetails;
    notFound?: boolean;
}

interface ErrorLocationState {
    error?: ErrorDetails;
}

const getReasonKey = (error: ErrorDetails): string =>
    `status.error.reason.${error.kind}`;

const ErrorPage: FunctionComponent<ErrorPageProps> = ({ error: suppliedError, notFound = false }) => {
    const location = useLocation();
    const state = location.state as ErrorLocationState | null;
    const error = suppliedError ?? state?.error ?? {
        kind: notFound ? "not-found" : "generic",
    } as ErrorDetails;

    return (
        <ApolloPage loading={false} needsLogin={false}>
            <SharedErrorPage
                description={i18n.t(getReasonKey(error))}
                detailsLabel={i18n.t("status.error.details")}
                error={error}
                genericMessage={i18n.t("status.error.reason.generic")}
                heading={
                    <Title
                        level={1}
                        prefix={i18n.t("status.error.oops")}
                        content={i18n.t("status.error.problem")}
                    />
                }
                homeHref={toPublicUrl("/Home")}
                homeLabel={i18n.t("status.error.home")}
                httpStatusLabel={(status) => i18n.t("status.error.httpStatus", { status })}
                illustration={<img
                    src={toPublicUrl("/assets/oops.png")}
                    alt={i18n.t("status.error.oops")}
                />}
            />
        </ApolloPage>
    );
};

export default ErrorPage;
